import React from 'react';
import {Dropdown} from 'react-bootstrap';
import profile from '../../images/img.jpg';
import FontAwesome from 'react-fontawesome';
import {Link} from 'react-router-dom';
import './style.css';

class TopNavigation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            menuIsToggle: true
        };

        this.handleToggleMenu = this.handleToggleMenu.bind(this);
    }

    handleToggleMenu() {
        this.setState(prevState => ({
            menuIsToggle: !prevState.menuIsToggle
        }));
        let bodyClassList = document.getElementsByTagName("BODY")[0].classList;
        bodyClassList.remove(this.state.menuIsToggle ? 'nav-md' : 'nav-sm');
        bodyClassList.add(this.state.menuIsToggle ? 'nav-sm' : 'nav-md');
    }

    render() {
        const admin = this.props.loggedUser ? (this.props.loggedUser.firstname && this.props.loggedUser.surname) ? this.props.loggedUser.firstname + " " + this.props.loggedUser.surname : this.props.loggedUser.nickname : "Neznámý uživatel";
        let notifications = this.props.notifications ? this.props.notifications.sort((a,b) => a.time < b.time) : [];
        let unreadNotifications = notifications.filter((notification) => !notification.read);

        return (
            <div className="top-nav">
                <div className="nav-menu">
                    <nav>
                        <div className="nav toggle">
                            <a id="menu-toggle" onClick={this.handleToggleMenu}>
                                <FontAwesome  name="bars" tag="i" />
                            </a>
                        </div>
                        <ul className="nav navbar-nav navbar-right">
                            <li>
                                <Dropdown id="dropdown-user-profile">
                                    <DropdownToogle bsRole="toggle" className="user-profile">
                                        <img src={profile} alt=""/>
                                        {admin}
                                        {' '}
                                        <FontAwesome name="angle-down"/>
                                    </DropdownToogle>
                                    <DropdownMenu bsRole="menu" className="dropdown-menu">
                                        <DropdownItem eventKey="1" className="item" to="/Profile">Profil</DropdownItem>
                                        <DropdownItem eventKey="2" className="item" to="/Settings">Nastavení</DropdownItem>
                                        <DropdownItem eventKey="3" className="item" to="/Help">Nápověda</DropdownItem>
                                        <DropdownItem eventKey="4" className="item" to="/Logout">Odhlásit se</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </li>
                            <li>
                                <Dropdown id="dropdown-notificate">
                                    <DropdownToogle bsRole="toggle" className="info-notificate">
                                            <FontAwesome name="envelope-o" tag="i"/>
                                            <span className="badge bg-green">{unreadNotifications.length}</span>
                                    </DropdownToogle>
                                    <DropdownMenu bsRole="menu" className="dropdown-menu list-unstyled msg-list">
                                        <div className="notification-list">
                                        {
                                            [...notifications].map((notification, index) => {
                                                    let style = !notification.read ? {display: 'block'} : {display: 'none'};
                                                    switch (notification.messageType) {
                                                        case 'error':
                                                            style.background = '#ffcdd2';
                                                            style.borderLeft = '3px solid #ff4444';
                                                            break;
                                                        case 'warning':
                                                            style.background = '#fff9c4';
                                                            style.borderLeft = '3px solid #ffbb33';
                                                            break;
                                                        case 'success':
                                                            style.background = '#c8e6c9';
                                                            style.borderLeft = '3px solid #00C851';
                                                            break;
                                                        case 'info':
                                                            style.background = '#e3f2fd';
                                                            style.borderLeft = '3px solid #33b5e5';
                                                            break;
                                                        default:
                                                            style.background = '#f8f9fa';
                                                    }
                                                    return (
                                                        <DropdownItem to="/notifications" key={index} className="item" style={style}>
                                                            <span className="image">
                                                                <img src={profile} alt="Profilový obrázek"/>
                                                            </span>
                                                            <span>
                                                                <span>{admin}</span>
                                                                <span className="time">{notification.time}</span>
                                                            </span>
                                                            <span className="message">
                                                                {notification.message}
                                                            </span>
                                                        </DropdownItem>
                                                )}
                                            )
                                        }
                                        </div>
                                        <DropdownItem to="/notifications">
                                            <div className="text-center">
                                                <strong>Zobrazit všechna upozornění</strong>
                                                <FontAwesome name="fa-angle-right"/>
                                            </div>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        );
    }
}

export default TopNavigation;


class DropdownToogle extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.preventDefault();

        this.props.onClick(e);
    }

    render() {
        return (
            <Link to="" className={this.props.className} onClick={this.handleClick}>
                {this.props.children}
            </Link>
        );
    }
}

class DropdownItem extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.preventDefault();

        this.props.onClick(e);
    }

    render() {
        return (
            <li style={this.props.style} onClick={this.props.onClick}>
                <Link to={this.props.to}>
                    {this.props.children}
                </Link>
            </li>
        );
    }
}

class DropdownMenu extends React.Component {
    render() {
        return (
            <ul className={this.props.className}>
                {this.props.children}
            </ul>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/TopNavigation/index.js
 **/